import React from 'react';

export default function ListPanel({ title, items, selected, onSelect }) {
	return (
		<div className="list-panel">
			<div className="list-panel__header">{title}</div>
			<div className="list-panel__list">
				{items.map(item => (
					<div
						key={item.id}
						className={`list-panel__item ${selected === item.id ? 'list-panel__item--selected' : ''}`}
						onClick={() => onSelect(item.id)}
					>
						<div className="list-panel__item-left">
							{item.color && <div className="list-panel__dot" style={{ background: item.color }} />}
							<span className="list-panel__name">{item.name}</span>
						</div>
						<span className="list-panel__count">{(item.count ? item.count : 0).toLocaleString()}</span>
					</div>
				))}
			</div>
		</div>
	);
}
